import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { TranslatePipe } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-select-dialog',
  imports: [
    FormsModule,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatLabel,
    TranslatePipe,
    MatOption,
    MatSelect,
  ],
  templateUrl: './select-dialog.component.html',
})
export class SelectDialogComponent {
  options;
  label;
  text;
  option;
  afterOptionSelected;
  headline;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      options: { option: string; label: string }[];
      label: string;
      text: string;
      afterOptionSelected: (option: string) => void;
      headline?: string;
      selectedValue?: string;
    },
  ) {
    this.option = data.selectedValue ?? data.options[0].option;
    this.options = data.options;
    this.label = data.label;
    this.text = data.text;
    this.afterOptionSelected = () => data.afterOptionSelected(this.option);
    this.headline = data.headline ?? 'components.select-dialog.title';
  }
}
